module.exports = __webpack_public_path__ + "images/percentage_split.png";